import {inject, Injectable} from '@angular/core';
import {firstValueFrom} from 'rxjs';
import {HttpClient} from '@angular/common/http';
import {AlumnosByYearAula} from '@kilobytelab/types';
import {API_URL_TOKEN} from '../token';

@Injectable({
  providedIn: 'root'
})
export class ApiListService {

  private http = inject(HttpClient);
  private apiUrl = inject(API_URL_TOKEN);

  /*** listados ***/

  getListadoNombres(tipo: string): Promise<string> {
    const url = `${this.apiUrl}listados/nombres/${tipo}`;
    return firstValueFrom(this.http.get<string>(url))
  }
  getListadoBlanco(aula: number): Promise<string> {
    const url = `${this.apiUrl}listados/blanco/${aula}`;
    return firstValueFrom(this.http.get<string>(url))
  }
  getListadoComedor(aula: number): Promise<string> {
    const url = `${this.apiUrl}listados/comedor/${aula}`;
    return firstValueFrom(this.http.get<string>(url))
  }
  getListadoContactos(aula: number, orden: string): Promise<string> {
    const url = `${this.apiUrl}listados/contactos/${aula}/${orden}`;
    return firstValueFrom(this.http.get<string>(url))
  }
  getListadoHorarios(aula: number, mes: number, year: number): Promise<string> {
    const url = `${this.apiUrl}listados/horarios/${aula}/${mes}/${year}`;
    return firstValueFrom(this.http.get<string>(url))
  }
  printMateriales(material: string, filtro: string): Promise<string> {
    const url = `${this.apiUrl}listados/material/${material}/${filtro}`;
    return firstValueFrom(this.http.get<string>(url))
  }
  getAsistenciasSanidad(fecha: string, aula: string | number): Promise<string> {
    const url = `${this.apiUrl}listados/sanidad/${fecha}/${aula}`;
    return firstValueFrom(this.http.get<string>(url))
  }
  getExcelMarketing(): Promise<string> {
    const url = `${this.apiUrl}listados/excel/marketing`;
    return firstValueFrom(this.http.get<string>(url))
  }
  getListadoAulas(listado: AlumnosByYearAula[]): Promise<string> {
    const url = `${this.apiUrl}listados/byyearaula`;
    return firstValueFrom(this.http.put<string>(url, listado))
  }

}
